// ============================================================
// Student Fee Dashboard API Layer
// ============================================================

import client from './axios';

export const feeDashboardApi = {
  /**
   * Get student fee dashboard overview analytics
   * GET /student-fee-dashboard/overview?school_id=UUID&academic_session_id=UUID&collection_from=YYYY-MM-DD&collection_to=YYYY-MM-DD
   */
  getDashboardOverview: async (schoolId, params = {}) => {
    const cleanParams = { school_id: schoolId };
    if (params.academic_session_id) cleanParams.academic_session_id = params.academic_session_id;
    if (params.collection_from) cleanParams.collection_from = params.collection_from;
    if (params.collection_to) cleanParams.collection_to = params.collection_to;

    const response = await client.get('/student-fee-dashboard/overview', { params: cleanParams });
    return response.data;
  },
};
